import { useEffect, useRef, useState } from "react";
import { Check } from "lucide-react";

const FADE = "linear-gradient(to bottom, black calc(100% - 3rem), transparent 100%)";

export default function PlanFeatureList({
  features,
  expanded,
  onToggle,
  highlight = false,
  collapsedHeight = 416, // px; raise/lower to show more/fewer features when collapsed
  testId,
}) {
  const listRef = useRef(null);
  const [fullHeight, setFullHeight] = useState(0);

  useEffect(() => {
    const el = listRef.current;
    if (!el) return undefined;
    const measure = () => setFullHeight(el.offsetHeight);
    measure();
    if (typeof ResizeObserver === "undefined") return undefined;
    const ro = new ResizeObserver(measure);
    ro.observe(el);
    return () => ro.disconnect();
  }, [features]);

  const overflows = fullHeight > collapsedHeight;
  const faded = overflows && !expanded;
  const height = expanded && overflows ? fullHeight : collapsedHeight;
  const mask = faded ? FADE : "none";

  return (
    <div className="mt-6">
      <div
        className="overflow-hidden transition-[height] duration-500 ease-in-out"
        style={{ height, WebkitMaskImage: mask, maskImage: mask }}
      >
        <ul ref={listRef} className="space-y-3 text-sm">
          {features.map((f) => (
            <li key={f} className="flex items-start gap-2">
              <Check
                size={16}
                className={`mt-0.5 flex-none ${highlight ? "text-white" : "text-hotpink"}`}
              />
              <span>{f}</span>
            </li>
          ))}
        </ul>
      </div>

      <div className="mt-3 h-5">
        {overflows && (
          <button
            type="button"
            onClick={onToggle}
            data-testid={testId}
            className={`text-xs font-semibold underline-offset-2 hover:underline ${
              highlight ? "text-white" : "text-hotpink"
            }`}
          >
            {expanded ? "Show less" : "Show all features"}
          </button>
        )}
      </div>
    </div>
  );
}